import React from 'react';
import { Link } from 'react-router';
import { APP_ROUTES } from 'swag-client-common/constants/app-routes';
import classes from './super-speed-button.scss';
export const SuperSpeedButton = ({
  onClick
}) => {
  return /*#__PURE__*/React.createElement(Link, {
    className: classes.superSpeedButtonWrapper,
    onClick: onClick,
    to: APP_ROUTES.ALL_SWAG
  }, /*#__PURE__*/React.createElement("div", {
    className: classes.superSpeedButton
  }, "Shop Super Speed"));
};